module.exports = __webpack_public_path__ + "img/deletepan_btn.da3c5041.svg";